// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cline x1=%2712%27 y1=%272%27 x2=%2712%27 y2=%2710%27 stroke=%27%23ffcc01%27 stroke-width=%272%27/%3E%3Cline x1=%2712%27 y1=%2714%27 x2=%2712%27 y2=%2722%27 stroke=%27%23ffcc01%27 stroke-width=%272%27/%3E%3Cline x1=%272%27 y1=%2712%27 x2=%2710%27 y2=%2712%27 stroke=%27%23ffcc01%27 stroke-width=%272%27/%3E%3Cline x1=%2714%27 y1=%2712%27 x2=%2722%27 y2=%2712%27 stroke=%27%23ffcc01%27 stroke-width=%272%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-bg-color: #00ff11;
  --primary-color: #0d00ff;
  --label-color: #5900ff;
  --regPad: 0.2px;
}

/* :root {
  --primary-bg-color: #0b0f1a;
  --primary-color: #00eaff;
  --label-color: #00eaff;
  --regPad: 0.2px;
} */

/* :root {
  --primary-bg-color: #2a0000;
  --primary-color: #ff4d4d;
  --label-color: #ff4d4d;
  --regPad: 0.2px;
} */

:root {
  --primary-bg-color: black;
  --primary-color: white;
  --label-color: white;
  --regPad: 0.2px;
  --cell-txt-color: #ffffff;
}

:root {
  --primary-bg-color: rgb(31, 31, 31);
  --primary-color: #ffe100;
  --label-color: #ffe100;
  --regPad: 0.2px;
  --cell-txt-color: #ffffff;
}

/* :root {
  --primary-bg-color: grey;
  --primary-color: #ff31e0;
  --label-color: #ff35e7;
  --regPad: 0.2px;
} */

html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  background: var(--primary-bg-color);
  color: var(--primary-color);
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      12 12,
    crosshair;
}

/* Cursor for clickable elements - primary color crosshair */
* {
  cursor: inherit;
}

button,
a,
[onClick],
.cell-popup-link,
.inline-entity-link,
.library-item,
.library-logo {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      12 12,
    crosshair !important;
}

/* Cursor for draggable elements (map) - primary color crosshair */
.world-map-svg,
.map-wrapper,
.world-map-svg * {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      12 12,
    crosshair !important;
}

/* Cursor when actively dragging - primary color crosshair */
body.dragging,
body.dragging .world-map-svg,
body.dragging .map-wrapper,
body.dragging .world-map-svg * {
  cursor: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
      12 12,
    crosshair !important;
}

#root {
  width: 100%;
  height: 100%;
}

.app {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

p {
  margin: 0;
  color: var(--primary-color);
}
.app-header {
  padding: var(--regPad);
  left: 0;
  right: 0;
  margin: 0;
  border-bottom: 1px solid var(--primary-color);
  z-index: 9999;
  display: flex;
  flex-direction: row-reverse;
}

.app-header h1 {
  margin: 0;
  font-size: 1.4rem;
}

.app-header p {
  margin: 0.25rem 0 0;
  font-size: 0.9rem;
}

.controls {
  border-bottom: 1px solid var(--primary-color);
}

.file-inputs {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.status {
  font-size: 0.85rem;
}

.layout {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.map-panel {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  /* background-color: var(--primary-color); */
}

.map-wrapper {
  flex: 1 1;
  position: relative;
}

.map-wrapper svg {
  width: 100%;
  height: calc(100% - 0px);
  /* background-color: var(--primary-bg-color); */
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
  margin-top: 0.4rem;
  font-size: 0.8rem;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.swatch {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  border: 1px solid #020617;
}

.swatch-sites-region {
  background: #10b981;
}

.swatch-sites {
  background: #22c55e;
}

.swatch-region {
  background: #64748b;
}

.swatch-empty {
  background: #1f2933;
}

.details-panel .placeholder,
.map-panel .placeholder {
  padding: 0.75rem 0.9rem;
  font-size: 0.9rem;
}

.details-content {
  flex: 1 1;
  padding: 0.75rem 0.9rem;
  overflow: auto;
  font-size: 0.85rem;
  height: 100%;
}

.details-content pre {
  border-radius: 6px;
  border: 1px solid #111827;
  padding: 0.5rem;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 180px;
  overflow: auto;
}

/* experiement with blend modes on map objects */
/* .site-marker {
  mix-blend-mode: screen;
}
.figure-marker {
  mix-blend-mode: difference;
}
.cell {
  mix-blend-mode: color-dodge;
} */

.texture-previews {
  width: 100px;
  height: 100px;
  position: relative;
}

.texture-previews img {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  mix-blend-mode: exclusion;
}

.flex-row-full {
  display: flex;
  width: 100%;
  justify-content: space-between;
  border-bottom: 1px solid var(--primary-color);
}

.flex-row-full p {
  max-width: 80%;
}

.specs {
  margin-top: 10px;
}

.enemy p {
  color: red !important;
}

.subFigures {
  margin: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* 3 columns */
  gap: 1rem; /* space between children */
}

.subFigure {
  border: 1px solid var(--primary-color);
}

button {
  margin-top: 5px;
  border: 1px solid var(--primary-color);
  background-color: rgba(0, 0, 0, 0);
  color: var(--primary-color);
  width: 100%;
  border-radius: 6px;
  text-align: left;
}

button p {
  color: var(--primary-color);
}

button:hover {
  background-color: var(--primary-color);
  color: var(--primary-bg-color);
}

button:hover p {
  color: var(--primary-bg-color);
}

.progressBar {
  position: fixed;
  left: 0;
  margin: 0;
  top: 0;
  bottom: 0;
  z-index: 999999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 1rem;
  background: transparent;
  background-color: transparent;
}

.library-logo-container {
  position: fixed;
  right: 2rem;
  top: 15rem;
  margin-top: 0;
  margin-bottom: 2rem;
  background: transparent !important;
  background-color: transparent !important;
  padding: 0;
  border: none;
  opacity: 0.5;
}

.library-logo-disabled {
  pointer-events: none;
}

.library-logo {
  width: 70px;
  height: auto;
  cursor: pointer;
  transition: opacity 0.2s;
  background: transparent !important;
  background-color: transparent !important;
  border: 1px solid var(--primary-color);
  display: block;
  image-rendering: pixelated;
  mix-blend-mode: normal;
  opacity: 1;
}

.library-logo:hover {
  opacity: 0.7;
}

.cat_headline {
  margin-top: 50px;
  border-top: 2px solid var(--primary-color);
}

button:hover .cat_headline {
  margin-top: 50px;
  border-top: 2px solid var(--primary-bg-color);
}

g.hover {
  border: 2px solid blue;
  background-color: green;
}

/* svg {
  mix-blend-mode: difference;
} */

rect.cell-type-region {
  fill: green;
  /* mix-blend-mode: darken; */
}

rect.cell-type-site {
  fill: blue;
  /* mix-blend-mode: difference; */
}

rect.cell-type-structure {
  fill: #ec4899;
  /* mix-blend-mode: screen; */
}

rect.cell-type-figure {
  fill: red;
  /* mix-blend-mode: difference; */
}

rect.cell-type-writtenContent {
  fill: #f97316;
  /* mix-blend-mode: screen; */
}

rect.cell-type-undergroundRegion {
  fill: brown;
  /* mix-blend-mode: screen; */
}

rect.cell-type-ocean {
  stroke: #0f172a;
  opacity: 0;
}

.cell-label {
  color: var(--primary-color);
  fill: var(--primary-color);
}

.hover {
  mix-blend-mode: difference;
}
.book-content button {
  width: auto;
}

.loader {
  background-color: var(--primary-bg-color);
  position: fixed;
  top: 20px;
  bottom: 20px;
  right: 20px;
  left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.underground-region-forward {
  color: var(--label-color);
  width: auto;
  align-self: right;
}

/* .overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  pointer-events: none;
  background-image: url("https://art.pixilart.com/4c48ff9fe9fcce9.gif");
  mix-blend-mode: difference;
  background-repeat: no-repeat;
  opacity: 1;
  background-attachment: fixed;
  background-size: 100% 100%;
} */

/* .map-panel {
  mix-blend-mode: screen;
} */
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;;;GAKG;;AAEH;;;;;GAKG;;AAEH;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;;;GAKG;;AAEH;;EAEE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B;;aAEW;AACb;;AAEA,4DAA4D;AAC5D;EACE,eAAe;AACjB;;AAEA;;;;;;;EAOE;;wBAEsB;AACxB;;AAEA,kEAAkE;AAClE;;;EAGE;;wBAEsB;AACxB;;AAEA,4DAA4D;AAC5D;;;;EAIE;;wBAEsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6CAA6C;EAC7C,aAAa;EACb,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gDAAgD;AAChD;;;;;;;;GAQG;;AAEH;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC,EAAE,cAAc;EACrD,SAAS,EAAE,2BAA2B;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,OAAO;EACP,SAAS;EACT,MAAM;EACN,SAAS;EACT,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,wCAAwC;EACxC,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,kCAAkC;EAClC,wCAAwC;EACxC,sCAAsC;EACtC,cAAc;EACd,0BAA0B;EAC1B,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,SAAS;EACT,YAAY;EACZ,WAAW;EACX,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;;GAEG","sourcesContent":[":root {\n  --primary-bg-color: #00ff11;\n  --primary-color: #0d00ff;\n  --label-color: #5900ff;\n  --regPad: 0.2px;\n}\n\n/* :root {\n  --primary-bg-color: #0b0f1a;\n  --primary-color: #00eaff;\n  --label-color: #00eaff;\n  --regPad: 0.2px;\n} */\n\n/* :root {\n  --primary-bg-color: #2a0000;\n  --primary-color: #ff4d4d;\n  --label-color: #ff4d4d;\n  --regPad: 0.2px;\n} */\n\n:root {\n  --primary-bg-color: black;\n  --primary-color: white;\n  --label-color: white;\n  --regPad: 0.2px;\n  --cell-txt-color: #ffffff;\n}\n\n:root {\n  --primary-bg-color: rgb(31, 31, 31);\n  --primary-color: #ffe100;\n  --label-color: #ffe100;\n  --regPad: 0.2px;\n  --cell-txt-color: #ffffff;\n}\n\n/* :root {\n  --primary-bg-color: grey;\n  --primary-color: #ff31e0;\n  --label-color: #ff35e7;\n  --regPad: 0.2px;\n} */\n\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\nbody {\n  background: var(--primary-bg-color);\n  color: var(--primary-color);\n  cursor: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cline x1='12' y1='2' x2='12' y2='10' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='12' y1='14' x2='12' y2='22' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='2' y1='12' x2='10' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='14' y1='12' x2='22' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3C/svg%3E\")\n      12 12,\n    crosshair;\n}\n\n/* Cursor for clickable elements - primary color crosshair */\n* {\n  cursor: inherit;\n}\n\nbutton,\na,\n[onClick],\n.cell-popup-link,\n.inline-entity-link,\n.library-item,\n.library-logo {\n  cursor: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cline x1='12' y1='2' x2='12' y2='10' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='12' y1='14' x2='12' y2='22' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='2' y1='12' x2='10' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='14' y1='12' x2='22' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3C/svg%3E\")\n      12 12,\n    crosshair !important;\n}\n\n/* Cursor for draggable elements (map) - primary color crosshair */\n.world-map-svg,\n.map-wrapper,\n.world-map-svg * {\n  cursor: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cline x1='12' y1='2' x2='12' y2='10' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='12' y1='14' x2='12' y2='22' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='2' y1='12' x2='10' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='14' y1='12' x2='22' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3C/svg%3E\")\n      12 12,\n    crosshair !important;\n}\n\n/* Cursor when actively dragging - primary color crosshair */\nbody.dragging,\nbody.dragging .world-map-svg,\nbody.dragging .map-wrapper,\nbody.dragging .world-map-svg * {\n  cursor: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cline x1='12' y1='2' x2='12' y2='10' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='12' y1='14' x2='12' y2='22' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='2' y1='12' x2='10' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3Cline x1='14' y1='12' x2='22' y2='12' stroke='%23ffcc01' stroke-width='2'/%3E%3C/svg%3E\")\n      12 12,\n    crosshair !important;\n}\n\n#root {\n  width: 100%;\n  height: 100%;\n}\n\n.app {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\np {\n  margin: 0;\n  color: var(--primary-color);\n}\n.app-header {\n  padding: var(--regPad);\n  left: 0;\n  right: 0;\n  margin: 0;\n  border-bottom: 1px solid var(--primary-color);\n  z-index: 9999;\n  display: flex;\n  flex-direction: row-reverse;\n}\n\n.app-header h1 {\n  margin: 0;\n  font-size: 1.4rem;\n}\n\n.app-header p {\n  margin: 0.25rem 0 0;\n  font-size: 0.9rem;\n}\n\n.controls {\n  border-bottom: 1px solid var(--primary-color);\n}\n\n.file-inputs {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.status {\n  font-size: 0.85rem;\n}\n\n.layout {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n\n.map-panel {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  /* background-color: var(--primary-color); */\n}\n\n.map-wrapper {\n  flex: 1;\n  position: relative;\n}\n\n.map-wrapper svg {\n  width: 100%;\n  height: calc(100% - 0px);\n  /* background-color: var(--primary-bg-color); */\n}\n\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem 1rem;\n  margin-top: 0.4rem;\n  font-size: 0.8rem;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.swatch {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  border: 1px solid #020617;\n}\n\n.swatch-sites-region {\n  background: #10b981;\n}\n\n.swatch-sites {\n  background: #22c55e;\n}\n\n.swatch-region {\n  background: #64748b;\n}\n\n.swatch-empty {\n  background: #1f2933;\n}\n\n.details-panel .placeholder,\n.map-panel .placeholder {\n  padding: 0.75rem 0.9rem;\n  font-size: 0.9rem;\n}\n\n.details-content {\n  flex: 1;\n  padding: 0.75rem 0.9rem;\n  overflow: auto;\n  font-size: 0.85rem;\n  height: 100%;\n}\n\n.details-content pre {\n  border-radius: 6px;\n  border: 1px solid #111827;\n  padding: 0.5rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 180px;\n  overflow: auto;\n}\n\n/* experiement with blend modes on map objects */\n/* .site-marker {\n  mix-blend-mode: screen;\n}\n.figure-marker {\n  mix-blend-mode: difference;\n}\n.cell {\n  mix-blend-mode: color-dodge;\n} */\n\n.texture-previews {\n  width: 100px;\n  height: 100px;\n  position: relative;\n}\n\n.texture-previews img {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  mix-blend-mode: exclusion;\n}\n\n.flex-row-full {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--primary-color);\n}\n\n.flex-row-full p {\n  max-width: 80%;\n}\n\n.specs {\n  margin-top: 10px;\n}\n\n.enemy p {\n  color: red !important;\n}\n\n.subFigures {\n  margin: 20px;\n  display: grid;\n  grid-template-columns: repeat(2, 1fr); /* 3 columns */\n  gap: 1rem; /* space between children */\n}\n\n.subFigure {\n  border: 1px solid var(--primary-color);\n}\n\nbutton {\n  margin-top: 5px;\n  border: 1px solid var(--primary-color);\n  background-color: rgba(0, 0, 0, 0);\n  color: var(--primary-color);\n  width: 100%;\n  border-radius: 6px;\n  text-align: left;\n}\n\nbutton p {\n  color: var(--primary-color);\n}\n\nbutton:hover {\n  background-color: var(--primary-color);\n  color: var(--primary-bg-color);\n}\n\nbutton:hover p {\n  color: var(--primary-bg-color);\n}\n\n.progressBar {\n  position: fixed;\n  left: 0;\n  margin: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 999999;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 1rem;\n  background: transparent;\n  background-color: transparent;\n}\n\n.library-logo-container {\n  position: fixed;\n  right: 2rem;\n  top: 15rem;\n  margin-top: 0;\n  margin-bottom: 2rem;\n  background: transparent !important;\n  background-color: transparent !important;\n  padding: 0;\n  border: none;\n  opacity: 0.5;\n}\n\n.library-logo-disabled {\n  pointer-events: none;\n}\n\n.library-logo {\n  width: 70px;\n  height: auto;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  background: transparent !important;\n  background-color: transparent !important;\n  border: 1px solid var(--primary-color);\n  display: block;\n  image-rendering: pixelated;\n  mix-blend-mode: normal;\n  opacity: 1;\n}\n\n.library-logo:hover {\n  opacity: 0.7;\n}\n\n.cat_headline {\n  margin-top: 50px;\n  border-top: 2px solid var(--primary-color);\n}\n\nbutton:hover .cat_headline {\n  margin-top: 50px;\n  border-top: 2px solid var(--primary-bg-color);\n}\n\ng.hover {\n  border: 2px solid blue;\n  background-color: green;\n}\n\n/* svg {\n  mix-blend-mode: difference;\n} */\n\nrect.cell-type-region {\n  fill: green;\n  /* mix-blend-mode: darken; */\n}\n\nrect.cell-type-site {\n  fill: blue;\n  /* mix-blend-mode: difference; */\n}\n\nrect.cell-type-structure {\n  fill: #ec4899;\n  /* mix-blend-mode: screen; */\n}\n\nrect.cell-type-figure {\n  fill: red;\n  /* mix-blend-mode: difference; */\n}\n\nrect.cell-type-writtenContent {\n  fill: #f97316;\n  /* mix-blend-mode: screen; */\n}\n\nrect.cell-type-undergroundRegion {\n  fill: brown;\n  /* mix-blend-mode: screen; */\n}\n\nrect.cell-type-ocean {\n  stroke: #0f172a;\n  opacity: 0;\n}\n\n.cell-label {\n  color: var(--primary-color);\n  fill: var(--primary-color);\n}\n\n.hover {\n  mix-blend-mode: difference;\n}\n.book-content button {\n  width: auto;\n}\n\n.loader {\n  background-color: var(--primary-bg-color);\n  position: fixed;\n  top: 20px;\n  bottom: 20px;\n  right: 20px;\n  left: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.underground-region-forward {\n  color: var(--label-color);\n  width: auto;\n  align-self: right;\n}\n\n/* .overlay {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  pointer-events: none;\n  background-image: url(\"https://art.pixilart.com/4c48ff9fe9fcce9.gif\");\n  mix-blend-mode: difference;\n  background-repeat: no-repeat;\n  opacity: 1;\n  background-attachment: fixed;\n  background-size: 100% 100%;\n} */\n\n/* .map-panel {\n  mix-blend-mode: screen;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
